var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbroad07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.4,
    height: 97.888,
    viewBox: "0 0 120.4 97.888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2813",
    "data-name": "Group 2813",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2807",
    "data-name": "Group 2807",
    transform: "translate(0 24.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5047",
    "data-name": "Path 5047",
    d: "M79.08,382.379c4.6-8.742,1.009-16.592-8.02-18.921C68.589,354.47,60.682,351,52.022,355.739c-8.745-4.6-16.6-1-18.93,8.023-8.979,2.469-12.445,10.376-7.71,19.046-4.6,8.732-1.013,16.583,8.007,18.917,2.481,8.992,10.392,12.454,19.061,7.713,8.729,4.594,16.583,1.009,18.911-8.02C80.349,398.949,83.818,391.036,79.08,382.379Z",
    transform: "translate(-23.262 -353.619)",
    fill: "#729d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5048",
    "data-name": "Path 5048",
    d: "M35.569,414.609H43.8L40.7,375.1l5.7-7.255-.057-.046-5.786,5.525-1.1-14-.439.014L37.194,388.49l-7.906-9.764-.113.068,7.814,13.033Z",
    transform: "translate(-10.693 -341.503)",
    fill: "#4a2400"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2812",
    "data-name": "Group 2812",
    transform: "translate(17.137)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_994",
    "data-name": "Rectangle 994",
    width: 11.32,
    height: 18.375,
    transform: "translate(67.142 10.952)",
    fill: "#fac440"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5049",
    "data-name": "Path 5049",
    d: "M104.154,434.378H32.89V378.015L68.418,347.94l35.736,30.075Z",
    transform: "translate(-19.936 -340.908)",
    fill: "#e3e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5050",
    "data-name": "Path 5050",
    d: "M77.335,355.848l39.834,37.543h8.755l-48.589-47.7-48.59,47.7H37.5Z",
    transform: "translate(-28.745 -345.69)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_995",
    "data-name": "Rectangle 995",
    width: 15.294,
    height: 5.405,
    transform: "translate(65.155 5.678)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5090",
    "data-name": "Path 5090",
    d: "M0,0H18.118V31.682H0Z",
    transform: "translate(22.878 61.788)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_997",
    "data-name": "Rectangle 997",
    width: 15.27,
    height: 14.222,
    transform: "translate(24.303 63.798)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_998",
    "data-name": "Rectangle 998",
    width: 13.776,
    height: 12.83,
    transform: "translate(25.049 64.495)",
    fill: "#93cbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_999",
    "data-name": "Rectangle 999",
    width: 29.877,
    height: 26.612,
    transform: "translate(48.585 53.238)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1000",
    "data-name": "Rectangle 1000",
    width: 28.367,
    height: 25.101,
    transform: "translate(49.341 53.994)",
    fill: "#93cbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1001",
    "data-name": "Rectangle 1001",
    width: 21.233,
    height: 18.91,
    transform: "translate(37.97 24.176)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1002",
    "data-name": "Rectangle 1002",
    width: 19.722,
    height: 17.4,
    transform: "translate(38.725 24.93)",
    fill: "#93cbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1003",
    "data-name": "Rectangle 1003",
    width: 32.095,
    height: 2.253,
    transform: "translate(47.477 78.666)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2808",
    "data-name": "Group 2808",
    transform: "translate(69.453 69.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5051",
    "data-name": "Path 5051",
    d: "M56.94,369.466H51.049l.783,3.689h4.324Z",
    transform: "translate(-50.796 -364.997)",
    fill: "#fac761"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5052",
    "data-name": "Path 5052",
    d: "M51.98,370.07a2.457,2.457,0,0,1,2.8-2.025,2.96,2.96,0,0,1-2.456,3.113C51.662,371.308,51.98,370.07,51.98,370.07Z",
    transform: "translate(-48.98 -368.036)",
    fill: "#7eb033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5053",
    "data-name": "Path 5053",
    d: "M52.42,371.178a2.31,2.31,0,0,1-1.219-3,2.782,2.782,0,0,1,2.285,2.938C53.473,371.747,52.42,371.178,52.42,371.178Z",
    transform: "translate(-50.819 -367.741)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5054",
    "data-name": "Path 5054",
    d: "M51.934,371.811a2.765,2.765,0,0,1,.938-3.775,3.339,3.339,0,0,1,.144,4.466C52.553,373.108,51.934,371.811,51.934,371.811Z",
    transform: "translate(-49.752 -368.036)",
    fill: "#a1b400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5055",
    "data-name": "Path 5055",
    d: "M53.921,372.055a3.9,3.9,0,0,0,1.628-3.56,3.2,3.2,0,0,0-3.525,2.788,3.491,3.491,0,0,0-.066.772Z",
    transform: "translate(-48.87 -367.064)",
    fill: "#b1d132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5056",
    "data-name": "Path 5056",
    d: "M52.181,371.557H54.35A3.333,3.333,0,0,0,51,368.729,2.635,2.635,0,0,0,52.181,371.557Z",
    transform: "translate(-50.968 -366.566)",
    fill: "#b3d246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5057",
    "data-name": "Path 5057",
    d: "M56.94,369.466H51.049l.2.949h5.486Z",
    transform: "translate(-50.796 -364.997)",
    fill: "#cd3700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5058",
    "data-name": "Path 5058",
    d: "M55.984,372.352l.532-2.508H51.129l.531,2.508Z",
    transform: "translate(-50.625 -364.194)",
    fill: "#cd3700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5059",
    "data-name": "Path 5059",
    d: "M56.969,371a.4.4,0,0,1-.4.394H51.437a.392.392,0,0,1-.394-.394h0a.392.392,0,0,1,.394-.391h5.135a.394.394,0,0,1,.4.391Z",
    transform: "translate(-50.808 -362.57)",
    fill: "#cd3700"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2811",
    "data-name": "Group 2811",
    transform: "translate(39.25 36.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2809",
    "data-name": "Group 2809",
    transform: "translate(0 1.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5060",
    "data-name": "Path 5060",
    d: "M42.308,358.071a.478.478,0,1,1-.688.6.477.477,0,1,1,.688-.6Z",
    transform: "translate(-41.032 -357.616)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5061",
    "data-name": "Path 5061",
    d: "M41.635,358.493a.314.314,0,0,1-.031-.622.315.315,0,0,1,.031.622Z",
    transform: "translate(-41.218 -357.497)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5062",
    "data-name": "Path 5062",
    d: "M41.455,357.8l.008-.017.021.007.167.33,0,.02-.022-.006-.168-.33Z",
    transform: "translate(-40.981 -357.68)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5063",
    "data-name": "Path 5063",
    d: "M41.622,357.76l.015-.008.014.017-.042.368-.015.013-.014-.017.041-.368Z",
    transform: "translate(-40.714 -357.751)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5064",
    "data-name": "Path 5064",
    d: "M41.33,357.916l-.008-.017.02-.011.356.1.011.017-.019.011-.355-.1Z",
    transform: "translate(-41.265 -357.461)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5065",
    "data-name": "Path 5065",
    d: "M41.315,358.031l-.011-.011.013-.017.369-.037.015.014-.013.015-.371.036Z",
    transform: "translate(-41.304 -357.295)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5066",
    "data-name": "Path 5066",
    d: "M41.362,358.278l-.02,0v-.021l.244-.279h.022V358l-.244.278Z",
    transform: "translate(-41.223 -357.272)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5067",
    "data-name": "Path 5067",
    d: "M41.471,358.348h-.017l0-.019.207-.31.017,0,0,.02-.206.309Z",
    transform: "translate(-40.991 -357.189)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5068",
    "data-name": "Path 5068",
    d: "M41.533,358.381h-.017v-.022l.238-.281.022,0,0,.022-.241.281Z",
    transform: "translate(-40.85 -357.065)",
    fill: "#616801"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2810",
    "data-name": "Group 2810",
    transform: "translate(2.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5069",
    "data-name": "Path 5069",
    d: "M43.433,358.805a.725.725,0,1,1,.037-1.169A.845.845,0,0,1,43.433,358.805Z",
    transform: "translate(-42.093 -357.121)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5070",
    "data-name": "Path 5070",
    d: "M42.5,358.08a.314.314,0,0,1-.031-.622.315.315,0,0,1,.031.622Z",
    transform: "translate(-41.839 -357.258)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5071",
    "data-name": "Path 5071",
    d: "M42.3,357.406l.012-.012.016.014.021.371-.014.013-.016-.013-.019-.371Z",
    transform: "translate(-41.653 -357.394)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5072",
    "data-name": "Path 5072",
    d: "M42.635,357.483l.019,0,0,.021-.2.31-.022.006,0-.022.2-.311Z",
    transform: "translate(-41.372 -357.21)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5073",
    "data-name": "Path 5073",
    d: "M42.849,357.58l.017.007-.007.019-.33.171-.021-.006.007-.02.332-.171Z",
    transform: "translate(-41.211 -356.998)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5074",
    "data-name": "Path 5074",
    d: "M42.912,357.766l.009.015-.015.013-.369-.042-.014-.016.017-.011.369.04Z",
    transform: "translate(-41.182 -356.689)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5075",
    "data-name": "Path 5075",
    d: "M42.849,357.992l0,.018-.017.005-.333-.162-.007-.019.019-.008.333.162Z",
    transform: "translate(-41.242 -356.474)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5076",
    "data-name": "Path 5076",
    d: "M42.693,358.178v.018H42.67l-.271-.254v-.02h.022l.271.254Z",
    transform: "translate(-41.446 -356.271)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5077",
    "data-name": "Path 5077",
    d: "M42.161,357.5v-.019l.019,0,.3.213,0,.02-.021,0-.3-.214Z",
    transform: "translate(-41.951 -357.21)",
    fill: "#616801"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5078",
    "data-name": "Path 5078",
    d: "M44.023,359.367c0,.891-.528,1.61-1.181,1.61s-1.184-.719-1.184-1.61.531-1.616,1.184-1.616S44.023,358.476,44.023,359.367Z",
    transform: "translate(-40.553 -356.636)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5079",
    "data-name": "Path 5079",
    d: "M42.358,358.25l-.014-.012.01-.017.362-.082.02.011-.014.017-.362.082Z",
    transform: "translate(-39.093 -355.809)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5080",
    "data-name": "Path 5080",
    d: "M42.028,357.7l.013-.013.015.014.021.371-.015.015-.014-.014-.02-.37Z",
    transform: "translate(-39.764 -356.771)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5081",
    "data-name": "Path 5081",
    d: "M41.864,357.753l.007-.016.019.008.149.34-.007.018-.017-.008-.15-.34Z",
    transform: "translate(-40.113 -356.665)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5082",
    "data-name": "Path 5082",
    d: "M41.758,357.826l0-.017.019,0,.243.28v.02H42l-.243-.282Z",
    transform: "translate(-40.339 -356.512)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5083",
    "data-name": "Path 5083",
    d: "M42.361,358.313l-.01-.015.015-.013.369.031.013.015-.015.015-.371-.033Z",
    transform: "translate(-39.079 -355.5)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5084",
    "data-name": "Path 5084",
    d: "M42.353,358.43l-.01-.015.013-.013.371.032.012.016-.015.013-.369-.031Z",
    transform: "translate(-39.095 -355.252)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5085",
    "data-name": "Path 5085",
    d: "M41.972,358.454l.013.011-.012.017-.364.072-.018-.012.011-.017.364-.072Z",
    transform: "translate(-40.69 -355.141)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5086",
    "data-name": "Path 5086",
    d: "M41.977,358.365l.01.016-.019.013-.366-.042-.015-.016.018-.015.369.044Z",
    transform: "translate(-40.7 -355.425)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5087",
    "data-name": "Path 5087",
    d: "M41.988,358.249l.008.015-.017.014-.368-.044-.013-.016.015-.014.37.044Z",
    transform: "translate(-40.675 -355.673)",
    fill: "#616801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5088",
    "data-name": "Path 5088",
    d: "M41.566,358.568H44.5l-.441,2.075H42Z",
    transform: "translate(-40.746 -354.899)",
    fill: "#35404d"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1004",
    "data-name": "Rectangle 1004",
    width: 0.824,
    height: 25.101,
    transform: "translate(63.112 53.994)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1005",
    "data-name": "Rectangle 1005",
    width: 15.351,
    height: 0.823,
    transform: "translate(48.585 63.336)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1006",
    "data-name": "Rectangle 1006",
    width: 20.493,
    height: 0.8,
    transform: "translate(38.34 30.218)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1007",
    "data-name": "Rectangle 1007",
    width: 75.967,
    height: 4.417,
    transform: "translate(10.603 93.469)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1008",
    "data-name": "Rectangle 1008",
    width: 1.604,
    height: 2.799,
    transform: "translate(37.97 80.92)",
    fill: "#fac761"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5089",
    "data-name": "Path 5089",
    d: "M83.912,387.411c1.706-4.585-.456-8.5-5.272-9.685-1.491-5.175-6.082-7.129-11.051-4.332-5.082-2.607-9.592-.481-10.882,4.741-4.55,1.31-6.6,5.019-5.138,9.276Z",
    transform: "translate(35.91 -289.524)",
    fill: "#56770e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbroad07);
export default __webpack_public_path__ + "static/media/abroad-07.6540201c29da6890a275019d37f26eeb.svg";
export { ForwardRef as ReactComponent };